<template>
  <v-row
    align="center"
    class="option-menu"
  >
    <v-col
      cols="6"
      class="option-btn"
    >
      <n2-btn-submit
        :color="isThaiCharoenPlus ? '#404040' : isSevenColor ? '#FFD900' : isThaisiam ? '#0066cc' : isHuaypromt ? '#C70025' : isJertjarat ? '#c59943' : isLottoslot88 ? '#ff6378' : isChokCharoen ? '#0066cc' : '#841B1D'"
        class="option-btn--inner"
        :class="{
          'option-btn-bc': isBooncharern,
          'option-btn-cci': isCherdchai,
          'option-btn-scr': isSapcharern,
          'option-btn-pa': isPacharern,
        }"
        @click="gotoPayrate"
      >
        อัตราจ่ายหวย
      </n2-btn-submit>
    </v-col>
    <v-col
      cols="6"
      class="option-btn"
    >
      <n2-btn
        :color="isThaiCharoenPlus ? '#404040' : isSevenColor ? '#FFD900' : isThaisiam ? '#0066cc' : isHuaypromt ? '#C70025' : isJertjarat ? '#c59943' : isLottoslot88 ? '#ff6378' : isChokCharoen ? '#0066cc' : '#841B1D'"
        class="option-btn--inner"
        :class="{
          'option-btn-bc': isBooncharern,
          'option-btn-cci': isCherdchai,
          'option-btn-scr': isSapcharern,
          'option-btn-pa': isPacharern,
        }"
        @click="gotoRule"
      >
        กฎและกติกา
      </n2-btn>
    </v-col>
  </v-row>
</template>

<script>
import { ROUTE_RULE, ROUTE_PAYRATE } from '@/const/route'

export default {
  methods:{ 
    gotoRule () {
      this.$router.push({name: ROUTE_RULE})
    },

    gotoPayrate () {
      this.$router.push({name: ROUTE_PAYRATE})
    }
  }
}
</script>
<style>
.option-btn-bc {
  background: linear-gradient(90deg, #a47000 0%, #3e2b00 100%) !important;
}
.option-btn-cci {
  background: linear-gradient(90deg, #a47000 0%, #3e2b00 100%) !important;
}
.option-btn-scr {
  background: linear-gradient(
    #b3743c 0%,
    #cf8d48 25%,
    #c38243 50%,
    #b3743c 100%
  );
}
.option-btn-pa {
 background: linear-gradient(90deg, #5745ff 0%, #190065 100%) !important;
}
</style>
<style scoped>
.option-menu {
  background-color: rgba(0, 0, 0, 0.05);;
  border-radius: 20px;
  height: 100%;
}

.option-btn {
  padding-left: 4px;
  padding-right: 4px;
}

.option-btn--inner {
  border-radius: 16px !important;
}

@media only screen and (max-width: 480px) { 
  .option-btn {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
</style>